import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../Tooltip';
import Heading from '../../Heading';
import Badge from '../../Badge';
import { withFocusable } from '../../common/Focusable';
import { st, classes } from './FunnelBadge.st.css.js';
import { dataHooks } from '../constants';
class StandardBadge extends PureComponent {
    render() {
        const { value, className, focusableOnBlur, focusableOnFocus, dataHook } = this.props;
        return (React.createElement("div", { className: st(classes.badge, className), "data-hook": dataHook, tabIndex: 0, onBlur: focusableOnBlur, onFocus: focusableOnFocus },
            React.createElement("span", { className: classes.badgeContent },
                React.createElement(Heading, { className: classes.badgeText, size: "extraTiny", dataHook: dataHooks.badgeValue }, value))));
    }
}
class DarkBadge extends PureComponent {
    render() {
        const { value, className, focusableOnBlur, focusableOnFocus, dataHook } = this.props;
        return (React.createElement("div", { className: st(classes.darkBadge, className), "data-hook": dataHook, tabIndex: 0, onBlur: focusableOnBlur, onFocus: focusableOnFocus },
            React.createElement(Badge, { type: "transparent", dataHook: dataHooks.badgeValue }, value)));
    }
}
const FocusedStandardBadge = withFocusable(StandardBadge);
const FocusedDarkBadge = withFocusable(DarkBadge);
export const FunnelBadge = props => {
    const { tooltipContent, onTooltipShow, value, differenceBadgeSkin } = props;
    return (React.createElement(Tooltip, { dataHook: dataHooks.badgeTooltip, disabled: !tooltipContent, content: tooltipContent, onShow: onTooltipShow, moveBy: { y: 2 }, textAlign: "start", size: "small" }, differenceBadgeSkin === 'dark'
        ? React.createElement(FocusedDarkBadge, { value: value, dataHook: dataHooks.badge })
        : React.createElement(FocusedStandardBadge, { value: value, dataHook: dataHooks.badge })));
};
FunnelBadge.propTypes = {
    /** Badge's value */
    value: PropTypes.string.isRequired,
    /** Tooltip content. Can be either string or renderable node */
    tooltipContent: PropTypes.node,
    /** When provided, changes badge skin */
    differenceBadgeSkin: PropTypes.oneOf(['standard', 'dark']),
    /** Callback on tooltip content show event */
    onTooltipShow: PropTypes.func,
};
//# sourceMappingURL=FunnelBadge.js.map